import { EyeInvisibleOutlined, EyeTwoTone } from "@ant-design/icons";
import { Button, Form, Input, Space, Typography, message } from "antd";
import axios from "axios";
import { Key } from "lucide-react";
import { useEffect, useState } from "react";
import { Link, useHistory, useLocation } from "react-router-dom";
import loginImage from "../../assets/img/login-image.png";
import { PASSWORD_HINT, passwordRules } from "../../utils/formRules";
import "./style.less";

const { Title, Text, Paragraph } = Typography;

const VerifyUser = () => {
  const { search } = useLocation();
  const history = useHistory();

  const [loading, setLoading] = useState(false);
  const [linkId, setLinkId] = useState();

  useEffect(() => {
    const params = new URLSearchParams(search);
    const id = params.get("code");
    if (id) setLinkId(id);
  }, [search]);

  const onFinish = async (values) => {
    setLoading(true);

    try {
      const { data } = await axios.post("/auth/verifyMerchantUser", {
        linkId,
        ...values,
      });
      setLoading(false);
      if (data.statusCode === 200) {
        message.success("Бүртгэл баталгаажлаа.");
        history.push("/");
      }
    } catch (error) {
      setLoading(false);
    }
  };

  return (
    <div className="login-container">
      <div
        className="login-image"
        style={{
          backgroundImage: `url(${loginImage})`,
        }}
      />

      <div className="login-card">
        <Space direction="vertical" size={0} className="login-space">
          <Link to="/" className="login-redirect">
            Нэвтрэх
          </Link>
          {/*<img src={logo} className="login-logo" alt="welcome" />*/}
          <Title level={2} style={{ margin: 0 }}>
            Шинэ нууц үг
          </Title>
          <Paragraph style={{ marginTop: 0, marginBottom: 32 }}>
            <Text style={{ fontSize: 16 }}>
              Цаашид ашиглах нууц үгээ оруулна уу.
            </Text>
          </Paragraph>
          <Form className="login-form" onFinish={onFinish}>
            <Form.Item name="password" rules={passwordRules()} extra={PASSWORD_HINT}>
              <Input.Password
                style={{ padding: "0.7rem 0.7rem" }}
                size="large"
                prefix={<Key size={20} style={{ color: "#626F86" }} />}
                type="password"
                placeholder="Нууц үг"
                iconRender={(visible) =>
                  visible ? <EyeTwoTone /> : <EyeInvisibleOutlined />
                }
              />
            </Form.Item>
            <Form.Item
              name="confirmPassword"
              rules={[
                {
                  required: true,
                  message: "Нууц үгээ оруулна уу!",
                },
                ({ getFieldValue }) => ({
                  validator(_, value) {
                    if (!value || getFieldValue("password") === value)
                      return Promise.resolve();
                    return Promise.reject(new Error("Нууц үг ижил биш байна!"));
                  },
                }),
              ]}
            >
              <Input.Password
                style={{ padding: "0.7rem 0.7rem" }}
                size="large"
                prefix={<Key size={20} style={{ color: "#626F86" }} />}
                type="password"
                placeholder="Нууц үг давтах"
                iconRender={(visible) =>
                  visible ? <EyeTwoTone /> : <EyeInvisibleOutlined />
                }
              />
            </Form.Item>

            <Form.Item>
              <Button
                type="primary"
                size="large"
                htmlType="submit"
                className="login-form-button"
                loading={loading}
                style={{ marginTop: 16 }}
              >
                Хадгалах
              </Button>
            </Form.Item>
          </Form>
        </Space>
      </div>
    </div>
  );
};

export default VerifyUser;
